module.exports = __webpack_public_path__ + "img/silber-diplom.80c81554.svg";